export const passwordRegexpattern = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[\^$*.{}()?"!@#%&/\\,><':;|_~+\-¥=`])[a-zA-Z0-9^$*.{}()?"!@#%&/\\,><':;|_~+-¥=`]{8,}$/
